/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import useMousePosition from "../hooks/useMousePosition"
import { motion, AnimatePresence } from "framer-motion"
import { useLocation } from "@reach/router"
import Helmet from "react-helmet"
import DonateSection from "./DonateSection"
import Header from "./Header"
import Menu from "./Menu"
import Footer from "./Footer"
import "./layout.scss"
import "../styles/app.scss"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
        title
        description
        author
        keywords
        }
      }
    }
  `)
  const location = useLocation()

  React.useEffect(() => {
    console.log("mount")
  }, [])

  const [menuState, setMenuState] = useState(false)
  const [cursorHovered, setCursorHovered] = useState(false)

  // Locking the body from scrolling when menu is opened
  useEffect(() => {
    menuState
      ? document.body.classList.add("body-lock")
      : document.body.classList.remove("body-lock")
  }, [menuState])

  const { x, y } = useMousePosition()

  const pageTransition = {
    initial: {
      opacity: 0,
      y: "10px",
    },
    enter: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        // delay: 1
      },
    },
    exit: {
      opacity: 0,
      y: "10px",
      duration: 0.6,
      // delay: 5
    },
  }


  return (
<>
  <Helmet
    title={data.site.siteMetadata.title}
    meta={[
      { name: 'description', content: data.site.siteMetadata.description },
      { name: 'keywords', content: data.site.siteMetadata.keywords },
      { name: 'author', content: data.site.siteMetadata.author },
    ]}
  />

      <AnimatePresence exitBeforeEnter>
        <motion.div
          key={location.pathname}
          // exit={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // initial={{ opacity: 0 }}
          // transition={{ duration: 1, delay: 2 }}
          initial="initial"
          animate="enter"
          exit="exit"
          variants={pageTransition}
        >
          <motion.div
            animate={{
              x: x - 16,
              y: y - 16,
              scale: cursorHovered ? 1.2 : 1,
            }}
            transition={{
              ease: "linear",
              duration: 0.3,
            }}
            className="cursor"
          ></motion.div>
          <Header
            menuState={menuState}
            setMenuState={setMenuState}
            siteTitle={data.site.siteMetadata.title}
            setCursorHovered={setCursorHovered}
          />
          <Menu
            x={x}
            y={y}
            menuState={menuState}
            setMenuState={setMenuState}
            setCursorHovered={setCursorHovered}
          />
          <main>{children}</main>

          {/* <DonateSection
            title="Donate header here"
            text="Donate to our cause, every donation matters"
          /> */}

          <Footer 
          title="Kyle Kuzma Foundation"
          copyright="© {new Date().getFullYear()}"
          />

        </motion.div>
      </AnimatePresence>
      </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout


// export const query = graphql`
//   query SiteTitleQuery {
//     site {
//       siteMetadata {
//         title
//         description
//         author
//         keywords
//       }
//     }
//   }
// `

